// extracted by mini-css-extract-plugin
export default {"App":"App_App__ZLCrx","backgroundImage":"App_backgroundImage__A7QyW","gradientOverlay":"App_gradientOverlay__Ag2Ec"};